import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Locale } from '@/lib/i18n';

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

/**
 * #1853 — the cashier's display language. Defaults to Indonesian; English is
 * opt-in from the rail (or the login / device-setup screens) and remembered
 * on this terminal.
 */
export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: 'id',
      setLocale: (locale) => set({ locale }),
    }),
    { name: 'ticketbox-locale' },
  ),
);
